import React, { useState } from 'react';
import { useAccount } from 'wagmi';
import { useSearchParams } from 'react-router-dom';
import { useIsChartPaneOpen, useSetChartPaneOpen, useGetPredictionsStatus } from './context/PredictionsContext';
import TradingView from './components/TradingView';
import History from './History';
import GameBoard from './components/GameBoard';
import GameBar from './components/GameBar';
import ErrorNotification from './components/Notification/ErrorNotification';
import PauseNotification from './components/Notification/PauseNotification';
import { useT } from '../../i18n';
import { storedReferrer } from '../../referral';

const Desktop = () => {
  const t = useT();
  const isChartPaneOpen = useIsChartPaneOpen();
  const setIsChartPaneOpen = useSetChartPaneOpen();
  const status = useGetPredictionsStatus();
  const { address } = useAccount();
  const [searchParams] = useSearchParams();
  const [isHistoryPaneOpen, setIsHistoryPaneOpen] = useState(false);

  // ?ref=<address> from an invite link (never yourself)
  const ref = searchParams.get('ref') || storedReferrer(address);
  const referralAddress = ref && ref.toLowerCase() !== address?.toLowerCase() ? ref : null;

  return (
    <div className="flex flex-col">
      <GameBar
        onToggleChart={() => setIsChartPaneOpen(!isChartPaneOpen)}
        chartOpen={isChartPaneOpen}
        onToggleHistory={() => setIsHistoryPaneOpen(!isHistoryPaneOpen)}
        historyOpen={isHistoryPaneOpen}
      />

      <div className="flex min-h-[560px]">
        <div className="min-w-0 flex-1">
          <div
            className="overflow-hidden transition-all duration-300"
            style={{ height: isChartPaneOpen ? '42vh' : 0, opacity: isChartPaneOpen ? 1 : 0 }}
          >
            <div className="h-full border-b border-white/5">
              <TradingView />
            </div>
          </div>

          <div className="py-5">
            {status === 'error' && <ErrorNotification />}
            {status === 'paused' && <PauseNotification />}
            {status === 'loading' && <p className="py-20 text-center text-white/40">{t('bvb.loading')}</p>}
            {status === 'live' && <GameBoard referralAddress={referralAddress} />}
          </div>
        </div>

        <aside
          className={`overflow-y-auto border-l border-white/5 transition-all duration-200 ${
            isHistoryPaneOpen ? 'w-96 opacity-100' : 'w-0 opacity-0'
          }`}
          style={{ maxHeight: '80vh' }}
        >
          {isHistoryPaneOpen && <History />}
        </aside>
      </div>
    </div>
  );
};

export default Desktop;
